const omitDeep = require('omit-deep');

export const cleanApiInput = (input) => {
  console.log('INPUT', input);
  return omitDeep(input, ['__typename'])
};

